import React, { useEffect, useReducer, useState } from "react";
import translate from "../../../i18n/translate";
import ErrorPage from "../../shared/ErrorPage/ErrorPage";
import Loader from "../../shared/Loader/Loader";
import SubSkillCard from "../../shared/SubSkillCard/SubSkillCard";
import CompletionCard from "../../shared/CompletionCard/CompletionCard";
import Toaster from "../../shared/Toaster/Toaster";
import "./ProgressPage.scss";
import moment from "moment";
import { useIntl } from "react-intl";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import { CircularProgress } from "@material-ui/core";
import {
  ReachOverallInterface,
  ReachReportSkillList,
  ReachReportSubSkillList,
  LicenseObjectInterface,
  TestResultsDataInterface,
} from "../../../interfaces";
import Accordion from "@material-ui/core/Accordion/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import TestResultCard from "../../shared/TestResultCard/TestResultCard";
import ReactGA from "react-ga";
import allActions from "../../../redux/actions";
import { useSelector, useDispatch } from "react-redux";
import ChartsComponent from "../../shared/ChartsComponent/ChartsComponent";
import { useParams } from "react-router-dom";
import { soloProducts, progressPageIds, productList, sprintBusinessProducts } from "../../../globalConstants";
import { getUserNextAssessmentLevel } from "../../../utils/levelMapping";
import elevateMockData from "../../../data/MockData/elevateStructuredData.json";
import { getLearnerProgress } from "../../../redux/actions/learnerProgressDetailsAction";
import { getLearnerNewProgressDetailsAction } from "../../../redux/actions/getLearnerNewProgressDetailsAction";
import ProgressCertificate from "../../shared/CompletionCard/progressCertificate";
import ProgressBadge from "../../shared/CompletionCard/progressBadge";
import NoDataFound from "../../shared/NoDataFoundComponent/NoDataFound";
import { getProductName, getProductType, getRandomNumber } from "../../shared/utils/sharedUtils";
import { PRODUCT_TYPES } from "../../shared/utils/sharedConstants";
import ProgressCard from "./ProgressCard";
import ProgressAccordion from "./ProgressAccordionSummary";
import ProgressBar from "./ProgressBar";
import { remapJSON, separateIndivUnitCountBasedOnLevel } from "./customProgressData";
import { getCoursesByStatus } from "../MyScheduleComponentBlock/MySchedulePageUtils";
import { calculateOverallUnitsCompletion, fetchLevelData, generatePartSprint } from "./ProgressPageUtils";
import ProgressStep from "../ProgressDetailsPage/StepProgress/ProgressStep";
import LevelTabs from "../ProgressDetailsPage/SubComponent/LevelTabs";
const useStyles = makeStyles(() => ({
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: "rgba(0,0,0,0.0)",
  },
  tab: {
    "& .MuiBox-root": {
      padding: "0px",
    },
  },
}));

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
  prodId?: any;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, prodId, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${prodId}-${index}`}
      // aria-labelledby={`scrollable-auto-tab-${prodId}-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography component={"span"}>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
  prodId: PropTypes.any.isRequired,
};

function a11yProps_dynamic(index: number, prodId: any) {
  return {
    id: `scrollable-auto-tab-${prodId}-${index}`
  };
}

const ProgressPage: React.FC = () => {
  let [loaderFlag, setLoaderFlag] = useState(true);
  let [sololoaderFlag, setSoloLoaderFlag] = useState(false);
  const { paramProdID } = useParams();
  const intl = useIntl();
  const allInfo = useSelector((state: any) => state);
  const [pageInited, setPageInited] = useState(false);
  const dispatch = useDispatch();
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState<string | false>(false);
  const [, setL1Expanded] = React.useState<string | false>(false);
  const [, setL2Expanded] = React.useState<string | false>(false);
  const [productTabIndex, setProductTabIndex] = useState(0);
  const [soloTab, setSoloTab] = useState(0);
  const [elevateTab, setElevateTab] = useState(0);
  const [isSoloStructuredData, setSoloStructuredData] = useState(true);
  const [isInvalidURL, setIsInvalidURL] = useState(false);
  const [, setAllUnitsIndivList] = useState([]);
  const [, setAllUnitsIndivListSolo] = useState([]);
  const [, setStructuredLevelProgress] = useState([]);
  const [, setStructuredSoloData] = useState([]);
  const [structuredNewSoloData, setStructuredNewSoloData] = useState([]);
  const [activeCourse, setActiveCourse] = useState<any[]>([]);
  const [structuredElevateData, setStructuredElevateData] = useState<any[]>([]);
  const [levelsToBeRendered, setLevelsToBeRendered] = useState<any>([]);
  const [testResultsList, setTestResultsList] = useState<Array<TestResultsDataInterface> | undefined>([]);
  const [reachReportsCompletedList, setreachReportsCompletedList] = useState<ReachOverallInterface | undefined>(undefined);
  const [reachReportsSkillList, setreachReportsSkillList] = useState<Array<ReachReportSkillList> | undefined>(undefined);
  const [reachReportSubSkillsList, setreachReportSubSkillsList] = useState<Array<ReachReportSubSkillList> | undefined>(undefined);
  const [productsList, setProductsList] = useState<Array<LicenseObjectInterface> | undefined>(undefined);
  const [toastOptions, settoastOptions] = useReducer((state: any, newState: any) => ({ ...state, ...newState }), {
    toastOpen: false,
    toastSeverity: "error",
    toastMessageKey: "",
  });
  const [levelList, setlevelList] = useState<any[]>([]);
  const [levelLoaderFlag, setLevelLoaderFlag] = useState(true);
  const [individualProgressPageLoading, setIndividualProgressPageLoading] = useState(true);

  const handleToastOptionsDirect = (name: string, val: any) => {
    settoastOptions({ [name]: val });
  };

  const toasterHandle = (open: boolean, severity: string, messageKey: string) => {
    handleToastOptionsDirect("toastSeverity", severity);
    handleToastOptionsDirect("toastMessageKey", messageKey);
    handleToastOptionsDirect("toastOpen", open);
  };

  useEffect(() => {
    if (!allInfo.tmsCourses.isLoading && !allInfo.tmsCourses.isFailed && !allInfo.tmsCourses.data) {
      const uuId = allInfo.common.luuId;
      dispatch(allActions.tmsCoursesAction.getTMSCourses(uuId));
    }
  }, []);

  useEffect(() => {
    if (!allInfo.peopleInformation.isLoading && allInfo.peopleInformation.data) {
      const licenseList = allInfo.peopleInformation.data.getpeopleInformation.license;
      if(licenseList) {
        allInfo.peopleInformation.data.getpeopleInformation.license.filter((prod: any) => {
          const licenseName =  getProductType(prod);
          if (licenseName === PRODUCT_TYPES.SOLO) {
            dispatch(allActions.currentSoloCourseAction.getStoreSoloActiveCourseInfo(allInfo.common.leuId, prod.licenseId, prod.productId));
          } else if (licenseName === PRODUCT_TYPES.SPRINT) {
            const uuId = allInfo.common.luuId;
            if (allInfo.tmsCourses.data?.getTMSGetCourse) {
              let activeCourse = allInfo.tmsCourses.data.getTMSGetCourse.filter(
                (courseFilter: any) => courseFilter.status === "3" || courseFilter.status === "1"
              );
              let courseId = 0;
              if (activeCourse.length > 0) {
                courseId = activeCourse[0].courseId;
              } else {
                let latestCompleted = allInfo.tmsCourses.data.getTMSGetCourse.filter(
                  (courseFilter: any) => courseFilter.status === "5"
                );
                courseId =
                  latestCompleted.length > 0
                    ? latestCompleted.sort((a: any, b: any) => b.courseId - a.courseId)[0].courseId
                    : 0;
              }
              dispatch(
                allActions.currentCourseDetailsAction.getStoreActiveCourseInfo(
                  allInfo.common.leuId,
                  prod.licenseId,
                  prod.productId,
                  uuId,
                  courseId
                )
              ); 
            }
          }
        }); 
      }
    }
  }, [allInfo.peopleInformation, allInfo.tmsCourses]);

  useEffect(() => {
    if (allInfo.elevateAssessmentDetails.data) {
      let assessmentDetails = JSON.parse(allInfo.elevateAssessmentDetails.data.getElevateAssessmentDetails);
      const userId = allInfo.peopleInformation.data.getpeopleInformation.edgeUid;
      if (assessmentDetails.length > 0) {
        for (let assessment of assessmentDetails) {
          dispatch(allActions.getElevateTestResultAction.elevateTestResult(Number(userId), assessment.id));
        }
      }
    }
  }, [allInfo.elevateAssessmentDetails]);

  const getCurrentLevelTab = (currentCourseLevel: string) => {
    levelList.forEach((course, index) => {
      if(course?.title === currentCourseLevel) {
        setSoloTab(index)
        handlesSoloChange(null, index);
      };
      }
    );
  }

  useEffect(() => {
    if(allInfo.getLearnerDetails.data?.getLearnerInfo){
      if (!levelList.length && allInfo?.common?.productID) {
      let productName: string = getProductName(Number(allInfo.common.productID));
      let productType: string = getProductType(Number(allInfo.common.productID));
      if(productName && (productType === PRODUCT_TYPES.SOLO || productType === PRODUCT_TYPES.SPRINT)) {
        if(sessionStorage.getItem("isDemoUser")){
          let dummyData = require("../../../data/MockData/sprintBusinessEnglishDemoLevel.json");
          setlevelList(dummyData);
        } else {
          fetchLevelData(productName, setlevelList);
        }
      }
    } 
    let currentCourseLevel = allInfo?.currentSoloCourseDetails?.data?.Level ? allInfo?.currentSoloCourseDetails?.data?.Level :
    allInfo?.currentCourseDetails?.data?.Level;
    let currentCourseStatus = allInfo?.currentSoloCourseDetails?.data?.CourseStatus ? allInfo?.currentSoloCourseDetails?.data?.CourseStatus :
    allInfo?.currentCourseDetails?.data?.CourseStatus;
    if(levelList.length && currentCourseLevel && levelLoaderFlag){
      getCurrentLevelTab(currentCourseLevel);
      setLevelLoaderFlag(false);
    } else if(!currentCourseLevel && currentCourseStatus && levelList.length) {
      getCurrentLevelTab(levelList[0].title);
      setLevelLoaderFlag(false);
    }}
  }, [levelList, allInfo.common, allInfo.currentSoloCourseDetails, allInfo.currentCourseDetails, allInfo.getLearnerDetails.data]);

  useEffect(() => {
    if(!allInfo.getLearnerDetails.data?.getLearnerInfo){
      setlevelList([])
      setStructuredNewSoloData([]);
    }
  },[allInfo.getLearnerDetails.data])



  useEffect(() => {
    if (window.location.href.split("/")[4] && allInfo.common.productID !== window.location.href.split("/")[4]) {
      dispatch(allActions.commonActions.setProductID(window.location.href.split("/")[4]));
    }
  }, [window.location.href, allInfo.common.productID]);
 
  const handleProductChange = (event: any, newValue: any) => {
    const currentTabPid = event.currentTarget.getAttribute("data-product");
    const isProductTab = allInfo.peopleInformation.data.getpeopleInformation.license.some((product: any) => product.productId === currentTabPid);    
    setProductTabIndex(newValue);
    const pushURL: string = `${window.location.protocol}//${window.location.host}/progress`;
    let productID: string = "";
    if (productsList && !productsList[newValue].productId.includes("$")) {
      productID = productsList[newValue].productId;
      if(productID) {
          window.history.pushState(null, "", `${pushURL}/${productID}`);
      } else {
        window.history.pushState(null, "", `${pushURL}`)
      }
    } else {
      window.history.pushState(null, "", `${pushURL}`);
    }
    const currentCourseLevel = allInfo?.currentSoloCourseDetails?.data?.Level;
    if(levelList.length && currentCourseLevel && isProductTab && levelLoaderFlag){
      getCurrentLevelTab(currentCourseLevel);
      setLevelLoaderFlag(false);
    }
  };
  
  const shiftInitialTab = () => {
    if (parseInt(paramProdID as string) ? parseInt(paramProdID as string) : "") {
      switchTab();
    } else {
      setIsInvalidURL(true);
    }
  };

  const switchTab = () => {
    let productIndex = 0, prodIDFound = false;
    if (productsList && productsList.length > 0) {
      productsList.forEach((prod: any) => {
        if (prod.active) {
          let paramsProductID: any = window.location.pathname.split("/").pop();
          if (parseInt(paramsProductID as string) === parseInt(prod.productId)) {
            setProductTabIndex(productIndex);
            prodIDFound = true;
          }
          productIndex += 1;
        }
      });
      if (!prodIDFound) {
        setIsInvalidURL(true);
      }
    }
  };
  
  const handlesSoloChange = (event: any, newValue: number) => {
    const userId = allInfo.peopleInformation.data.getpeopleInformation.edgeUid;
    const level = levelList[newValue];  
    setSoloTab(newValue);
    setSoloLoaderFlag(true);
    dispatch(getLearnerNewProgressDetailsAction(userId.toString(), level.title.toString(), Number(allInfo.common.productID), " "));
  };

  const handleElevateChange = (event: any, newValue: any) => {
    setElevateTab(newValue);
  };

  let filledPartList: any = [];
  const calculateAllTotalPerSkill = (allSkillsList: any) => {
    let allSkillsTotal: any = [];
    allSkillsList.forEach((units: any, index: number) => {
      let perSkillTotalPrint = {
        id: index,
        name: units.skilltitle,
        prework: 0,
        homework: 0,
        sessions: 0,
        totalprework: 0,
        totalhomework: 0,
        totalsessions: 0,
        userTestScore: 0,
        maxTestScore : 0,
        level: units.skilllevel,
        skillType : "",
      };

      let consolidatedListObj = units.skillcourses[units.skillcourses.length - 1];
      perSkillTotalPrint["prework"] += parseInt(consolidatedListObj.preworkcompleted);
      perSkillTotalPrint["totalprework"] += parseInt(consolidatedListObj.totalprework);
      perSkillTotalPrint["homework"] += parseInt(consolidatedListObj.homeworkcompleted);
      perSkillTotalPrint["totalhomework"] += parseInt(consolidatedListObj.totalhomework);
      perSkillTotalPrint["sessions"] += parseInt(consolidatedListObj.sessioncompleted);
      perSkillTotalPrint["totalsessions"] += parseInt(consolidatedListObj.totalsession);
      if(consolidatedListObj.skilltypeid === "digital_test") {
        perSkillTotalPrint["skillType"] = consolidatedListObj.skilltypeid;
        perSkillTotalPrint["userTestScore"] += parseInt(consolidatedListObj.usertestscore);
        perSkillTotalPrint["maxTestScore"] += parseInt(consolidatedListObj.maxtestscore);
      }
      allSkillsTotal.push(perSkillTotalPrint);
    });
    return allSkillsTotal;
  };

  const renderReachSubSkill = (reachReportSubSkillsList: Array<object>, skillID: string) => {
    let subskillFilteredList: any = [];
    if (reachReportSubSkillsList && reachReportSubSkillsList.length > 0) {
      reachReportSubSkillsList.forEach((subskill: any, index: number) => {
        if (subskill.SkillId === skillID) {
          subskillFilteredList.push(            
            <div key={index} className="mission-container">
              <div className="mission-title">{subskill.BadgeName}</div>
              <div className="mission-bar">
                <ProgressBar progressPercentage = {parseInt(subskill["TotalMission"]) !== 0 ? (parseInt(subskill["MissionPassed"]) / parseInt(subskill["TotalMission"])) * 100 : 0 }></ProgressBar>
              </div>
              <div className="mission-metric">
                {subskill["MissionPassed"]}/{subskill["TotalMission"]}
              </div>
            </div>
          );
        }
      });
    }
    return subskillFilteredList;
  };

  const afterGetReachProgress = () => {
    if (!allInfo.reachProgress.isLoading) {
      if (!allInfo.reachProgress.isFailed && allInfo.reachProgress.data) {
        const reachReportsData = JSON.parse(allInfo.reachProgress.data.getReachReport);
        setreachReportsCompletedList(reachReportsData.data[0]);
        setreachReportsSkillList(reachReportsData.data[1]);
        setreachReportSubSkillsList(reachReportsData.data[2]);
        // handle error page here - false
      } else {
        // handle error page here - true
      }
    }
  };

  const getReachProgress = async () => {
    // License check for Reach API
    let licensesList: any =
      allInfo.peopleInformation && allInfo.peopleInformation.data && allInfo.peopleInformation.data.getpeopleInformation
        ? allInfo.peopleInformation.data.getpeopleInformation.license.map((obj: any) => ({ ...obj }))
        : [];
    const licenseIDList = getOnlyIds(licensesList) || [];
    if (licenseIDList.indexOf("15") >= 0) {
      const { accountId, token }: any = allInfo.peopleInformation.data.getpeopleInformation;
      if (!allInfo.reachProgress.data && !allInfo.reachProgress.isLoading) {
        dispatch(allActions.reachProgressAction.getReachProgress(allInfo.common.leuId, accountId, token));
      }
    }
  };

  const sugarCoatNamesAndFilter = (rawLics: Array<LicenseObjectInterface>) => {
    let finalRawLicenses: any = [],
      rawLicenseArr: Array<LicenseObjectInterface> = rawLics;
    const mandatoryTabs: any = [
      {
        productId: "$0",
        productName: intl.formatMessage({ "id" : "progress_activity_report" }),
        active: 1,
      },
      {
        productId: "$1",
        productName: intl.formatMessage({ "id" : "progress_test_results" }),      
        active: 1,
      }
    ];

    let sugarCoatedPrefixes = progressPageIds.map((id: string) => {
      let productObj = productList.find((product: any) => product.productId === id);
      return {
        productId: id,
        productName: productObj ? productObj.productName : "",
      };
    });
    rawLicenseArr = [...mandatoryTabs, ...rawLicenseArr];
    sugarCoatedPrefixes = [...sugarCoatedPrefixes, ...mandatoryTabs];

    // Remove licenses based on active state
    for (let k = 0; k < rawLicenseArr.length; k++) {
      if (parseInt(rawLicenseArr[k]["active"]) === 0) {
        rawLicenseArr.splice(k, 1);
      }
    }

    for (let i = 0; i < rawLicenseArr.length; i++) {
      for (let j = 0; j < sugarCoatedPrefixes.length; j++) {
        if (rawLicenseArr[i]["productId"] === sugarCoatedPrefixes[j]["productId"]) {
          finalRawLicenses.push(rawLicenseArr[i]);
        }
      }
    }

    // sugarcoat names in licenses
    for (let i = 0; i < finalRawLicenses.length; i++) {
      for (let j = 0; j < sugarCoatedPrefixes.length; j++) {
        if (parseInt(finalRawLicenses[i]["active"]) === 1) {
          if (finalRawLicenses[i]["productId"] === sugarCoatedPrefixes[j]["productId"]) {
            finalRawLicenses[i]["productName"] = sugarCoatedPrefixes[j]["productName"];
          }
        } else {
          finalRawLicenses.splice(i, 1);
        }
      }
    }
    let productIds = finalRawLicenses.map((product: any) => product.productId);
    if (productIds.includes("18") || productIds.includes("29")) {
      finalRawLicenses = finalRawLicenses.filter((product: any) => product.productId !== "15");
    }
    return finalRawLicenses;
  };

  const getOnlyIds = (licenseArr: any) => {
    let lArr: any = [];
    if (licenseArr && licenseArr.length > 0) {
      licenseArr.map((prod: any) => {
        lArr.push(prod.productId);
      });
    }
    return lArr;
  };

  const afterGetTestResultsAPI = () => {
    if (!allInfo.testProgress.isLoading) {
      if (!allInfo.testProgress.isFailed) {
        if (allInfo.testProgress.data) {
          if(!allInfo.testProgress.data["learnerTestResults"]){
            setTestResultsList(allInfo.testProgress.data);
          } else {
            setTestResultsList(allInfo.testProgress.data["learnerTestResults"])
          }
          // handle error page here - false
        }
      } else {
        // handle error page here - true
      }
      getReachProgress();
    }
  };

  const initGoogleAnalytics = () => {
    if (allInfo.peopleInformation.data.getpeopleInformation.serviceConfiguration.features.substring(84, 85) === "1") {
      const trackingId: string = process.env.REACT_APP_GA_TRACKING_ID || "";
      ReactGA.initialize(trackingId);
      const url = window.location.pathname;
      ReactGA.set({ page: url });
      ReactGA.pageview(url);
    }
  };

  const afterGetPeopleInfo = () => {
    if (!allInfo.peopleInformation.isFailed && allInfo.peopleInformation.data) {
      let licensesList: any =
        allInfo.peopleInformation &&
        allInfo.peopleInformation.data &&
        allInfo.peopleInformation.data.getpeopleInformation
          ? allInfo.peopleInformation.data.getpeopleInformation.license.map((obj: any) => ({ ...obj }))
          : [];
      // handle error page here - false
      initGoogleAnalytics();
      setProductsList(sugarCoatNamesAndFilter(licensesList));
      setLoaderFlag(false);
    } else {
      // handle error page here - true
    }
  };

  const getPeopleInfo = () => {
    afterGetPeopleInfo();
  };

  const handleAccordionChange = (panel: string, level?: number) => (event: React.ChangeEvent<{}>, isExpanded: boolean) => {
    if (level === 1) {
      setL1Expanded(isExpanded ? panel : false);
    } else if (level === 2) {
      setL2Expanded(isExpanded ? panel : false);
    } else {
      setExpanded(isExpanded ? panel : false);
    }
  };

  const filterSpecificProductCourses = (data: any, ID: number, isSolo = false) => {
    return {
      skilllevel: data.skilllevel,
      skilltitle: data.skilltitle,
      userid: data.userid,
      username: data.username,
      skillcourses: !isSolo ? data.skillcourses.filter((course: any) => course.skilltypeid === ID) : data.skillcourses,
    };
  };

  const restructureSprintLevelProgressData = (data: any, isSolo = false) => {
    let structuredArr: any = [],
      levelsList: any = [];

    if (data && data.data && data.data.userskillscourseslist && data.data.userskillscourseslist.length > 0) {
      data.data.userskillscourseslist.map((datum: any) => {
        if (levelsList.indexOf(datum.skilllevel) === -1) {
          let singleDataObj: any = {
            level: datum.skilllevel,
            courses: [],
          };
          singleDataObj.courses.push(filterSpecificProductCourses(datum, 2, isSolo));
          structuredArr.push(singleDataObj);
          levelsList.push(datum.skilllevel);
        } else {
          for (let i = 0; i < structuredArr.length; i++) {
            if (structuredArr[i].level === datum.skilllevel) {
              structuredArr[i].courses.push(filterSpecificProductCourses(datum, 2, isSolo));
            }
          }
        }
      });
    }

    if (structuredArr && structuredArr.length > 0) {
      let sortedCourses: any = structuredArr[0].courses.sort((a: any, b: any) =>
        a.skillcourses[0].courseparttitle.toLowerCase().localeCompare(b.skillcourses[0].courseparttitle.toLowerCase())
      );
      structuredArr[0]["courses"] = sortedCourses;
      for (let i = 0; i < structuredArr.length; i++) {
        structuredArr[i].parts = {
          parts: generatePartSprint(structuredArr[i], isSolo, filledPartList),
        };
      }
      return structuredArr;
    } else return [];
  };




  const afterSprintLevelProgressAPI = (reStructuredWithTotal: any) => {
    for (let i = 0; i < reStructuredWithTotal.length; i++) {
      reStructuredWithTotal[i].parts.parts.map((singleFilledPart: any) => {
        let allCompletedListUnitbefore: any = calculateAllTotalPerSkill(singleFilledPart.courses)
        singleFilledPart.total = calculateOverallUnitsCompletion(separateIndivUnitCountBasedOnLevel(allCompletedListUnitbefore) || []);
      });
    }
    const simplifiedJSON: any = [];
    let remappedJSON: any = {};
    remappedJSON["skilltitle"] = {};
    allInfo.learnerProgressDetails.data.map((eachObject: any) => {
      simplifiedJSON.push(remapJSON(remappedJSON, eachObject, {}, true));
    });
    let allCompletedListUnitbefore: any = calculateAllTotalPerSkill(simplifiedJSON);
    setAllUnitsIndivList(
      mergeUnits(calculateOverallUnitsCompletion(separateIndivUnitCountBasedOnLevel(allCompletedListUnitbefore) || []))
    );
    setStructuredLevelProgress(reStructuredWithTotal);
  };

  const afterLearnerProgressAPI = () => {
    let userskillscourseslist: any = {};
    userskillscourseslist.data = {};
    userskillscourseslist.data.userskillscourseslist = [];
    if (!allInfo.learnerProgressDetails.isLoading) {
      if (!allInfo.learnerProgressDetails.isFailed && allInfo.learnerProgressDetails.data) {
        let reStructuredWithTotal: any;
        let remappedJSON: any = {};
        remappedJSON["skilltitle"] = {};
        allInfo.learnerProgressDetails.data.map((progressDetails: any) => {
          userskillscourseslist = remapJSON(remappedJSON, progressDetails, userskillscourseslist, false)
        });
        reStructuredWithTotal = restructureSprintLevelProgressData(userskillscourseslist, true)
        if (allInfo.common.productID === "20") {
          afterSprintLevelProgressAPI(reStructuredWithTotal);
        } else {
          if (
            allInfo.learnerProgressDetails &&
            allInfo.learnerProgressDetails.data &&
            allInfo.learnerProgressDetails.data &&
            typeof allInfo.learnerProgressDetails.data === "object" &&
            allInfo.learnerProgressDetails.data.length > 0
          ) {
            for (let i = 0; i < reStructuredWithTotal.length; i++) {
              reStructuredWithTotal[i].parts.parts.map((singleFilledPart: any) => {
                let allCompletedListUnitbefore: any = calculateAllTotalPerSkill(singleFilledPart.courses);
                singleFilledPart.total = calculateOverallUnitsCompletion(
                  separateIndivUnitCountBasedOnLevel(allCompletedListUnitbefore) || []
                );
              });
            }

            let allCompletedListUnitbefore: any = calculateAllTotalPerSkill(
              userskillscourseslist.data.userskillscourseslist
            );
            setAllUnitsIndivListSolo(mergeUnits(calculateOverallUnitsCompletion(separateIndivUnitCountBasedOnLevel(allCompletedListUnitbefore) || [])));
            setSoloStructuredData(false);
            setStructuredSoloData(reStructuredWithTotal);
          } else {
            setSoloStructuredData(false);
            setAllUnitsIndivListSolo([]);
          }
        }
      }
      if (allInfo.learnerProgressDetails.data.length === 0) setSoloStructuredData(false);
    }
  };

  const getLearnerProgressAPI = async () => {
    if (allInfo.peopleInformation.data) {
      const userId = allInfo.peopleInformation.data.getpeopleInformation.edgeUid;
      dispatch(getLearnerProgress(userId.toString(), Number(allInfo.common.productID)));
    }
  };

  const mergeUnits = (unmergedList: any) => {
    let allUnitsList: any = [];
    for (let i = 0; i < unmergedList.length; i++) {
      allUnitsList.push(...unmergedList[i].units);
    }
    return allUnitsList;
  };

  const getPartTitle = (partTitle?: string) => {
    if (partTitle) {
      return (
        <div className="h5_title">
          {translate("progress_partText")} {partTitle}
        </div>
      );
    } else {
      return <div className="h5_title">--</div>;
    }
  };

  useEffect(() => {
    if (productsList && productsList.length > 0) {
      shiftInitialTab();
    }
  }, [productsList]);

  useEffect(() => {
    setPageInited(true);
    sessionStorage.removeItem("chInited");  
  }, []);

  useEffect(() => {
    if (!allInfo.common.isLoading && !allInfo.peopleInformation.isLoading) {
      if (!allInfo.peopleInformation.isFailed && allInfo.peopleInformation.data) {
        getPeopleInfo();
      }
    }
  }, [allInfo.common, allInfo.peopleInformation]);

  // ======================= Start of Elevate progress fetch ======================
  const extractLevelValueAlone = () => {
    return levelsToBeRendered.slice().map((levelsObj: any) => levelsObj.level);
  };

  useEffect(() => {
    if (levelsToBeRendered.length > 0) {
      const availableLevels = extractLevelValueAlone();
      if (!allInfo.elevateAssessmentDetails.isLoading && !allInfo.elevateAssessmentDetails.data) {
        dispatch(allActions.elevateAssessmentDetailsAction.elevateAssessmentDetails("EN", availableLevels.join(",")));
      }
    }
  }, [levelsToBeRendered]);

  useEffect(() => {
    if (
      allInfo.common.productID === "25" &&
      !allInfo.tmsLearnerSessions.isLoading &&
      !allInfo.tmsLearnerSessions.data &&
      !sessionStorage.getItem("isDemoUser")
    ) {
      dispatch(allActions.tmsLearnerSessionsAction.getStoreTMSLearnerSessionInfo(allInfo.common.luuId));
    } else {
      if (
        allInfo.tmsLearnerSessions.data &&
        allInfo.createSessionService.data &&
        levelsToBeRendered.length > 0 &&
        activeCourse.length > 0
      ) {
        let sortedSessions = allInfo.tmsLearnerSessions.data.getTMSLearnerSessions
          .slice()
          .sort((a: any, b: any) => b.startTime - a.startTime)
          .reverse();
        let filteredSessions = sortedSessions.filter(
          (sessionObj: any) => (sessionObj.status === "finished" || sessionObj.status === "lost") && activeCourse[0].courseId === sessionObj.course
        );
        let statistics = allInfo.createSessionService.data.createSessionService;
        if (filteredSessions.length > 0) {
          restructureElevateData(filteredSessions, levelsToBeRendered, statistics);
        }
      }
    }

    if (
      allInfo.common.productID === "25" &&
      !allInfo.createSessionService.isLoading &&
      !allInfo.createSessionService.data &&
      activeCourse.length > 0 &&
      !sessionStorage.getItem("isDemoUser")
    ) {
      dispatch(allActions.createSessionServiceAction.createSessionService(activeCourse[0].courseId));
    }
  }, [
    allInfo.peopleInformation,
    allInfo.tmsLearnerSessions,
    allInfo.createSessionService,
    activeCourse,
    levelsToBeRendered,
  ]);

  const restructureElevateData = (sessions: any, levelsToBeRendered: any, sessionsStatics: any) => {
    let elevateSessionsData: any = [];
    let elevateCourseLength = Number(sessionsStatics.length) / 18;
    for (let i = 0; i <= elevateCourseLength - 1; i++) {
      let tempObj: any = {};
      tempObj["level"] = levelsToBeRendered[i].level;
      let partSessions = sessions.splice(0, 18);
      let partsObj: any = {
        coursePartTitle: levelsToBeRendered[i].part,
        level: levelsToBeRendered[i].level,
        statistics: {
          totalsessions: 18,
          sessions: partSessions.length,
        },
      };
      let sessionsCompleted: any = [];
      partSessions.forEach((session: any, index: number) => {
        let sessionObj: any = {};
        sessionObj["subskilltitle"] = `Session ${index + 1}`;
        sessionObj["sessionStatus"] = session.status;
        let getTime = `${moment.unix(parseInt(session.endTime)).format("DD MMM YYYY / hh:mm A")} ${moment.unix(parseInt(session.endTime)).tz(moment.tz.guess()).format("z")}`
        sessionObj["sessioncompleteddate"] = getTime || "--";
        sessionsCompleted.push(sessionObj);
      });
      partsObj["sessionsCompleted"] = sessionsCompleted;
      if (elevateSessionsData.length > 0) {
        let foundLevelObj = elevateSessionsData.find((obj: any) => obj.level === levelsToBeRendered[i].level);
        foundLevelObj
          ? foundLevelObj.parts.push(partsObj)
          : elevateSessionsData.push({ level: levelsToBeRendered[i].level, parts: [partsObj] });
      } else {
        elevateSessionsData.push({ level: levelsToBeRendered[i].level, parts: [partsObj] });
      }
    }
    setStructuredElevateData(elevateSessionsData);
  };

  useEffect(() => {
    if (
      allInfo.getLearnerDetails.data &&
      !allInfo.peopleInformation.isLoading &&
      allInfo.peopleInformation.data &&
      allInfo.createSessionService.data &&
      !sessionStorage.getItem("isDemoUser")
    ) {
      if (allInfo.getLearnerDetails.data.getLearnerInfo) {
        let courseLevel = allInfo.getLearnerDetails.data.getLearnerInfo.CourseLevel;
        let courseLength = Number(allInfo.createSessionService.data.createSessionService.length);
        if (courseLength / 18 === 1) {
          setLevelsToBeRendered([
            {
              level: courseLevel,
              part: "A",
            },
          ]);
        } else if (courseLength / 18 === 2) {
          setLevelsToBeRendered([
            {
              level: courseLevel,
              part: "A",
            },
            {
              level: courseLevel,
              part: "B",
            },
          ]);
        } else if (courseLength / 18 === 4) {
          const nextLevel = getUserNextAssessmentLevel(courseLevel);
          setLevelsToBeRendered([
            {
              level: courseLevel,
              part: "A",
            },
            {
              level: courseLevel,
              part: "B",
            },
            {
              level: nextLevel,
              part: "A",
            },
            {
              level: nextLevel,
              part: "B",
            },
          ]);
        }
      }
      if(allInfo.tmsCourses.data) {
        const activeCourse = getCoursesByStatus(allInfo.tmsCourses.data.getTMSGetCourse);
        setActiveCourse(activeCourse);
      }
    }

    if (allInfo.common.productID && !allInfo.getLearnerDetails.isLoading && !allInfo.getLearnerDetails.data && !sessionStorage.getItem("isDemoUser")) {
      dispatch(allActions.getLearnerDetailsAction.getLearnerDetails(allInfo.common.leuId, Number(allInfo.common.productID)));
    }
  }, [allInfo.peopleInformation, allInfo.getLearnerDetails, allInfo.createSessionService, allInfo.tmsCourses, allInfo.common]);
  // ====================== End ==========================

  useEffect(() => {
    if (!allInfo.testProgress.isLoading) {
      afterGetTestResultsAPI();
    }
  }, [allInfo.testProgress]);

  useEffect(() => {
    if (!allInfo.reachProgress.isLoading) {
      afterGetReachProgress();
    }
  }, [allInfo.reachProgress]);
  
  // Common effect for all products
  useEffect(() => {
    if (!allInfo.learnerProgressDetails.isLoading && !allInfo.learnerProgressDetails.isFailed && ((soloProducts.includes(allInfo.common.productID) || sprintBusinessProducts.includes(allInfo.common.productID)))) {
    (allInfo.learnerProgressDetails.data) ? afterLearnerProgressAPI() : getLearnerProgressAPI();
    }
  }, [allInfo.peopleInformation, allInfo.common.productID]);

  const getDateAndTimeFormat =(timestamp: number) => {
    return moment
    .unix(timestamp)   
    .tz(moment.tz.guess(true)) 
    .format("DD MMMM YYYY | hh:mm A z");
  }

  const afterGetLearnerProgressDetails =() =>{    
   let getLearnerProgressModuleDetails: any = allInfo.getLearnerProgressDetails.data.modules;

   let courseModuleObj: any = [];
   let perPartTotalExercise: number = 0;
   let perPartCompletedExercise: number = 0;
   let perPartTotalSession: number = 0;
   let perPartCompletedSession: number = 0;
   let perPartTotalCorrectnessPercentage: number = 0;
   let perPartUserScore: number = 0;   
   let perPartMaxScore: number = 0;
   let perPartSessionDetail: string = "";
   getLearnerProgressModuleDetails.map((courseModule: any) => {
    let courseMainTitle = courseModule?.coursePart?.title,
        courseMainUnitList = courseModule?.units?.length && courseModule?.units,
        courseExist: boolean = false,
        isDigitalTest: Boolean = false,
        courseIndex: number = 0,
        perModuleTotalExercise: number = 0,
        perModulecompletedExercise: number = 0,
        perModuleCompletedPercent: string = "",
        perModuleExerciseDetail: string = "",
        perModuleTotalSession: number = 0,
        perModulecompletedSession: number = 0,
        perModuleSessionPercent: string = "",
        perModuleSessionDetail: string = "",
        perModuleTotalCorrectnessPercentage: number = 0,
        perModuleCorrectnessPercentage: number = 0,
        courseUnitObj: any = [],              
        cumulativeTestResults: any = {
          type: "digital_test",
          UserScore: 0,
          MaxScore: 0
        },       
        cumulativeSessionUnits: any = { 
          "type": "unit",
          "perUnitTotalSession" : 0,
          "perUnitcompletedSession" : 0          
        }, 
        courseDetailObj = {
          ...courseModule,
          units: courseUnitObj
        };
        
    courseMainUnitList.map((courseUnit: any, courseUnitIndex: number) => {
      const courseMainLearningObjectsList = courseUnit?.learningObjects.length && courseUnit?.learningObjects;
      courseMainLearningObjectsList.map((courseLearning: any) => {
        isDigitalTest = courseLearning.type === "digital_test" ? true  : false;        
        if (!isDigitalTest) {          
          if(courseLearning.type === "lesson"){
            let totalStatExersiceCount: number = 0,
             totalCorrectStatExersiceCount: number = 0,
             totalCorrectnessPercentage: number = 0,
             indexActivityCount: any = courseLearning?.exercises?.filter((eachActivity: any, index:number) => {
               return eachActivity.type === "index";
             });

            const totalExercise = courseLearning?.exercises?.length - indexActivityCount.length,
            completedExerciseList = totalExercise && courseLearning?.exercises.filter(
                                                    (exercise: any , exerciseIndex: number) => exercise.Status === 2),
            completedExercise = completedExerciseList?.length,
            totalStatExersice = totalExercise && courseLearning?.exercises.map((exer:any,exerIndex: number) => {
              if(exer?.Stat != null){                    
                  return totalStatExersiceCount += isNaN(parseInt(exer.Stat.split(",")[2])) ? 0 : parseInt(exer.Stat.split(",")[2]);                            
              }
            }),
            completedStatExersice = totalExercise && courseLearning?.exercises.map((exer:any,exerIndex: number) => {
              if(exer?.Stat != null){                    
                  return totalCorrectStatExersiceCount += isNaN(parseInt(exer.Stat.split(",")[1])) ? 0 : parseInt(exer.Stat.split(",")[1]);  
              }
            });
                          
          totalCorrectnessPercentage = Math.round((totalCorrectStatExersiceCount / totalStatExersiceCount) * 100);                                                                
          perModuleTotalCorrectnessPercentage += isNaN(totalCorrectnessPercentage) ? 0 : totalCorrectnessPercentage;                    
          perModuleTotalExercise += isNaN(totalExercise) ? 0 : totalExercise;
          perModulecompletedExercise += isNaN(completedExercise) ? 0 : completedExercise;
          
          // cumulative total Exercise and completed Exercise for Units
          let cumulativeUnits = { 
            "type": "unit",
            "perUnitTotalExercise" : totalExercise,
            "perUnitcompletedExercise" : completedExercise,
            "totalCorrectnessPercentage": totalCorrectnessPercentage,
            "perUnitExercisePercentage" : completeBarTotalFormat(completedExercise, totalExercise, true),
            "perUnitExerciseDetails" : completeBarTotalFormat(completedExercise, totalExercise)
          }
          courseUnit = Object.assign({}, courseUnit, cumulativeUnits);
          
          }else{
            const totalSession = 1;
            const completedSessionCheck = totalSession && courseLearning?.sessionDetails?.Status;
            const sessionStartTimeTimeStamp = totalSession && courseLearning?.sessionDetails?.StartTime;
            const sessionStartTime = getDateAndTimeFormat(sessionStartTimeTimeStamp);
            let completedSession: any = 0;
            let upcomingSession: any = 0;
            
            if((completedSessionCheck === 2) ){
              completedSession = 1;
            }
            if(completedSessionCheck === 0){
              upcomingSession = 1;
            }
             
            perModuleTotalSession += isNaN(totalSession) ? 0 : totalSession;
            perModulecompletedSession += isNaN(completedSession) ? 0 : completedSession;
            cumulativeSessionUnits = {   
              "type": "unit",            
              "perUnitTotalSession" : totalSession,
              "perUnitcompletedSession" : completedSession,
              "sessionStartTime": sessionStartTime  ,
              "perUnitUpcomingSession":   upcomingSession        
            }

            courseUnit = Object.assign({}, courseUnit, cumulativeSessionUnits);            
          } 

          courseUnitObj.push(courseUnit);                  

        } else {
          // Digital Test total Exercise and completed Exercise for Units
          let testDetail = courseLearning?.testDetails?.length && courseLearning?.testDetails;
          let competenceList: any = [];
          let competenceTotalPercentage: number = 0;
          if (!testDetail?.length) {
            cumulativeTestResults = {
              type: "digital_test",
              UserScore: 0,
              MaxScore: 0,
              competenceTotalPercentage: 0,
              perModuleExerciseDetail: completeBarTotalFormat(0, 0),
              perModuleCompletedPercent: completeBarTotalFormat(0, 0, true)
            }
            courseUnit = Object.assign({}, courseUnit, cumulativeTestResults);
            courseUnitObj.push(courseUnit);
            return;
          }
          {testDetail?.length && testDetail.map((currentTestResult: any) => {
            let testResult = currentTestResult?.Competence?.length ? currentTestResult : undefined;
            if (!testResult) {
              cumulativeTestResults = {
                type: "digital_test",
                UserScore: 0,
                MaxScore: 0,
                competenceTotalPercentage: 0,
                perModuleExerciseDetail: completeBarTotalFormat(0, 0),
                perModuleCompletedPercent: completeBarTotalFormat(0, 0, true)
              }
              courseUnit = Object.assign({}, courseUnit, cumulativeTestResults);
              return;
            }
            const totalDigitalTest = testResult?.Competence?.length && testResult?.Competence.map((competence: any) => {
            let competenceTitle: string = competence?.competency,
                competenceCurrentScore: number = competence?.currentScore,
                competenceMaxScore: number = competence?.maxScore,
                competencePercentage: number = Math.round((competenceCurrentScore / competenceMaxScore) * 100),
                competenceObj = {
                  competenceTitle,
                  competencePercentage
                };
                competenceList.push(competenceObj);
                competenceTotalPercentage += competencePercentage; 
            });
            competenceTotalPercentage = Math.round(competenceTotalPercentage / testResult?.Competence.length);
            perModuleExerciseDetail = completeBarTotalFormat(testResult.UserScore, testResult.MaxScore);
            perModuleCompletedPercent = completeBarTotalFormat(testResult.UserScore, testResult.MaxScore, true);
            cumulativeTestResults = {
              type: courseLearning.type,
              UserScore: testResult.UserScore ?? 0,
              MaxScore: testResult.MaxScore ?? 0,
              competenceList,
              competenceTotalPercentage,
              perModuleExerciseDetail,
              perModuleCompletedPercent
            }
            courseUnit = Object.assign({}, courseUnit, cumulativeTestResults);
          });
          courseUnitObj.push(courseUnit);
        }}              
      });
      perModuleExerciseDetail = completeBarTotalFormat(perModulecompletedExercise, perModuleTotalExercise);
      perModuleSessionDetail = completeBarTotalFormat(perModulecompletedSession, perModuleTotalSession);
      perModuleCompletedPercent = completeBarTotalFormat(perModulecompletedExercise, perModuleTotalExercise, true);
      perModuleSessionPercent = completeBarTotalFormat(perModulecompletedSession, perModuleTotalSession, true);
      if (!isDigitalTest) {        
        // cumulative total Exercise and completed Exercise for Module         
        perModuleCorrectnessPercentage = perModuleTotalCorrectnessPercentage/courseMainUnitList?.length;
        let cumulativeModules = { 
          "perModuleTotalExercise" : perModuleTotalExercise,
          "perModulecompletedExercise" : perModulecompletedExercise,
          "perModuleTotalSession": perModuleTotalSession,
          "perModulecompletedSession": perModulecompletedSession,
          "perModuleCorrectnessPercentage": perModuleCorrectnessPercentage,
          "perModuleSessionDetail" : perModuleSessionDetail,
          "perModuleExerciseDetail": perModuleExerciseDetail,
          "perModuleCompletedPercent" : perModuleCompletedPercent,
          "perModuleSessionPercent" : perModuleSessionPercent
        }

        courseDetailObj = Object.assign({}, courseDetailObj, cumulativeModules);
      } else {
        // Digital Test total Exercise and completed Exercise for Module
        courseDetailObj = Object.assign({}, courseDetailObj, cumulativeTestResults);
      }
    });
    
    courseDetailObj.units = Array.from(new Map(courseUnitObj.map((v: any) => [v.id, v])).values());
    // check if course object exists in array or not
    courseModuleObj.some((eachCourse: any, index: number) => {
      if (eachCourse?.courseTitle === courseMainTitle){        
        courseExist = true; 
        courseIndex = index; 
        perPartTotalExercise += isNaN(perModuleTotalExercise) ? 0 : perModuleTotalExercise;
        perPartCompletedExercise += isNaN(perModulecompletedExercise) ? 0 : perModulecompletedExercise;      
        perPartTotalSession += isNaN(perModuleTotalSession) ? 0 : perModuleTotalSession;
        perPartCompletedSession += isNaN(perModulecompletedSession) ? 0 : perModulecompletedSession;      
        perPartTotalCorrectnessPercentage += isNaN(perModuleCorrectnessPercentage) ? 0 : perModuleCorrectnessPercentage;  
        perPartUserScore += isNaN(cumulativeTestResults.UserScore) ? 0 : cumulativeTestResults.UserScore;      
        perPartMaxScore += isNaN(cumulativeTestResults.MaxScore) ? 0 : cumulativeTestResults.MaxScore;             
      } 
    });
    // forming course object
    let dialogContentLocal = (
      <div>
        <h6>{translate("progress_overall_card_title_certificate")}:</h6>
        <p>{translate("progress_badge_dialog_box_title")}</p>
        {(allInfo.common.productID !== "25") && 
          <>
            <h6>{translate("progress_overall_card_title_badge")}:</h6>
            <ul>
              <li>{translate("progress_badge_dialog_box_golden")}</li>
              <li>{translate("progress_badge_dialog_box_silver")}</li>
              <li>{translate("progress_badge_dialog_box_bronze")}</li>
            </ul>
          </>
        }
        <p>
          {(allInfo.common.productID === "21" || allInfo.common.productID === "22"|| allInfo.common.productID === "23"|| allInfo.common.productID === "24") && <>*{translate("progerss_badge_dailog_box_digitalActivities")}.</>
          }
          {(allInfo.common.productID == "20" || allInfo.common.productID == "18" || allInfo.common.productID == "26" || allInfo.common.productID == "27" || allInfo.common.productID == "28") &&             
            <>*{translate("progress_badge_dailog_box_liveSessions")}.</>
          }
          {(allInfo.common.productID == "25") && <>{translate("progress_elevate_dialog_box_liveSessions")}.</>}
        </p>
      </div>
    );
    let completedExercisePercent = Math.round((perPartCompletedExercise/perPartTotalExercise) * 100);
    let completedSessionPercent = Math.round((perPartCompletedSession/perPartTotalSession) * 100);
    let completedDigitalExercisePercent = Math.round((perPartUserScore/perPartMaxScore) * 100);
    let percentagePartCompletedExercise = isNaN(completedExercisePercent) ? 0 : completedExercisePercent;
    let percentagePartCompletedSession = isNaN(completedSessionPercent) ? 0 : completedSessionPercent;
    let percentagePartCompletedDigitalExercise = isNaN(completedDigitalExercisePercent) ? 0 : completedDigitalExercisePercent;    
    let certificateAvailability: any;
    if((allInfo.common.productID === "20" || allInfo.common.productID === "26"|| 
        allInfo.common.productID === "27"|| allInfo.common.productID === "28")) {
      certificateAvailability = (percentagePartCompletedExercise > 70) && (percentagePartCompletedSession > 70) ? true : false;
    } else {      
      certificateAvailability = (percentagePartCompletedExercise > 70) && (percentagePartCompletedDigitalExercise > 70) ? true : false;
    }
    if (!courseExist) {
      // new course      
      perPartTotalExercise = perModuleTotalExercise;
      perPartCompletedExercise = perModulecompletedExercise;
      perPartTotalSession = perModuleTotalSession;
      perPartCompletedSession = perModulecompletedSession;
      perPartTotalCorrectnessPercentage = perModuleCorrectnessPercentage;                 
      perPartUserScore = cumulativeTestResults.UserScore;      
      perPartMaxScore = cumulativeTestResults.MaxScore;
      perPartSessionDetail = completeBarTotalFormat(perPartCompletedSession, perPartTotalSession);
      courseModuleObj.push({
        courseTitle: courseMainTitle,
        certificateAvailability,
        dialogContentLocal,
        perPartTotalExercise,
        perPartCompletedExercise,
        perPartTotalSession,
        perPartCompletedSession,
        percentagePartCompletedExercise,
        percentagePartCompletedSession,
        perPartTotalCorrectnessPercentage,
        perPartUserScore,
        perPartMaxScore,
        perPartSessionDetail,
        courseDetailObj: [courseDetailObj]
      })
    } else {
      // existing course
      courseModuleObj[courseIndex].perPartTotalExercise = perPartTotalExercise;
      courseModuleObj[courseIndex].perPartCompletedExercise = perPartCompletedExercise;
      courseModuleObj[courseIndex].perPartTotalSession = perPartTotalSession;
      courseModuleObj[courseIndex].perPartCompletedSession = perPartCompletedSession;
      courseModuleObj[courseIndex].perPartSessionDetail = completeBarTotalFormat(perPartCompletedSession, perPartTotalSession);
      courseModuleObj[courseIndex].percentagePartCompletedExercise = percentagePartCompletedExercise;
      courseModuleObj[courseIndex].percentagePartCompletedSession = percentagePartCompletedSession;
      courseModuleObj[courseIndex].certificateAvailability = certificateAvailability;
      courseModuleObj[courseIndex].perPartTotalCorrectnessPercentage = perPartTotalCorrectnessPercentage;
      courseModuleObj[courseIndex].perPartUserScore = perPartUserScore;
      courseModuleObj[courseIndex].perPartMaxScore = perPartMaxScore;
      courseModuleObj[courseIndex].courseDetailObj.push(courseDetailObj);
    }        
  })
  
  courseModuleObj.map((eachCourse: any, index: number) => {
    let percentagePartCompletedExercise: any = 0;
    let perPartDigitalScorePercentage: any = 0;
    let perPartTotalCorrectnessPercentage: any = 0;
    let badgeAvailability: any = false;

    let courseCorrectObj = eachCourse?.courseDetailObj?.filter((eachDetailObj: any, index: number) => {
     return eachDetailObj.type === "module";
    });

    if(eachCourse?.perPartTotalCorrectnessPercentage) eachCourse.perPartTotalCorrectnessPercentage = (eachCourse?.perPartTotalCorrectnessPercentage)/ courseCorrectObj.length;

    if(eachCourse?.perPartUserScore && eachCourse?.perPartMaxScore) eachCourse.perPartDigitalScorePercentage = ((eachCourse?.perPartUserScore)/(eachCourse?.perPartMaxScore)) * 100;
    else eachCourse.perPartDigitalScorePercentage = 0;
    
    if(eachCourse?.percentagePartCompletedExercise) percentagePartCompletedExercise = (40*eachCourse?.percentagePartCompletedExercise)/100;
    if(eachCourse?.perPartDigitalScorePercentage) perPartDigitalScorePercentage = (40*eachCourse?.perPartDigitalScorePercentage)/100;
    if(eachCourse?.perPartTotalCorrectnessPercentage) perPartTotalCorrectnessPercentage = (20*eachCourse?.perPartTotalCorrectnessPercentage)/100;
    
    eachCourse.perPartBadgePercentage = Math.round(percentagePartCompletedExercise + perPartDigitalScorePercentage + perPartTotalCorrectnessPercentage);    
    if(eachCourse.perPartBadgePercentage >= 50){
      badgeAvailability = true;
      eachCourse.badgeAvailability = badgeAvailability;
    }else{
      eachCourse.badgeAvailability = badgeAvailability;
    }    
  });
    setStructuredNewSoloData(courseModuleObj);         
  }

  const completeBarTotalFormat = (completed: any = 0, total: any = 0, percent: boolean = false) => {
    if (percent) {
      const percent = Math.round((completed / total) * 100);
      const percentText = isNaN(percent) ? 0 : percent;
      return `${ percentText }%`;
    } else {
      return `(${completed} / ${total})`;
    }
  }

  useEffect(() => {
    if (!allInfo.getLearnerProgressDetails.isLoading && !allInfo.getLearnerProgressDetails.isFailed && allInfo.getLearnerProgressDetails.data &&
      ((soloProducts.includes(allInfo.common.productID) || sprintBusinessProducts.includes(allInfo.common.productID)))) {            
      setSoloLoaderFlag(false);
      afterGetLearnerProgressDetails();
    } else if (!allInfo.getLearnerProgressDetails.isLoading && allInfo.getLearnerProgressDetails.isFailed) {
      setSoloLoaderFlag(false);
      setStructuredNewSoloData(allInfo.getLearnerProgressDetails.data);
    }
  }, [allInfo.getLearnerProgressDetails]);

  useEffect(() => {
    if (
      !allInfo.peopleInformation.isLoading &&
      !allInfo.skillsProgress.isLoading &&
      !allInfo.testProgress.isLoading &&
      !allInfo.reachProgress.isLoading &&
      (!soloProducts.includes(allInfo.common.productID) ||
        (soloProducts.includes(allInfo.common.productID) && !isSoloStructuredData))
    ) {
      if (isInvalidURL) {
        setTimeout(() => {
          window.history.pushState(null, "", `${window.location.protocol}//${window.location.host}/progress`);
        }, 1000);
      }
    }
  }, [
    allInfo.peopleInformation,
    allInfo.skillsProgress,
    allInfo.testProgress,
    allInfo.reachProgress,
    allInfo.sprintLevelProgress,
    isSoloStructuredData,
  ]);

  useEffect(() => {
    if(allInfo.reachProgress.isLoading || allInfo.skillsProgress.isLoading || allInfo.getLearnerProgressDetails.isLoading || allInfo.learnerProgressDetails.isLoading){
      setIndividualProgressPageLoading(true);
    } else {
      setIndividualProgressPageLoading(false);
    }
  },[allInfo.reachProgress.isLoading, allInfo.skillsProgress.isLoading, allInfo.getLearnerProgressDetails.isLoading, allInfo.learnerProgressDetails.isLoading])

  useEffect(() => {
    if (!allInfo.peopleInformation.isFailed && allInfo.peopleInformation.data && allInfo.common.productID) {
      const userId = allInfo.peopleInformation.data.getpeopleInformation.edgeUid;
      if (
        !allInfo.skillOutcomeSummary.isLoading &&
        !allInfo.skillOutcomeSummary.isFailed &&
        !allInfo.skillOutcomeSummary.data && 
        allInfo.common.productID !== "25"
      ) {
        dispatch(allActions.skillOutcomeSummaryAction.getSkillOutcome(userId.toString(), Number(allInfo.common.productID)));
      }
    }

    if (sessionStorage.getItem("isDemoUser") && allInfo.common.productID === "25") {
      setStructuredElevateData(elevateMockData);
    }
  }, [allInfo.peopleInformation, allInfo.common.productID, allInfo.skillOutcomeSummary]);


  

  useEffect(() => {
    if (!allInfo.peopleInformation.isLoading && allInfo.peopleInformation.data && !sessionStorage.getItem('isDemoUser')) {
      let licences = allInfo.peopleInformation.data.getpeopleInformation.license;
      if (licences.length > 0) {
        dispatch(allActions.commonActions.setProductID(licences[0].productId));
      }
    }

    if (!allInfo.peopleInformation.isLoading && !allInfo.tmsCourses.isLoading) {
      if (allInfo.peopleInformation.data && allInfo.tmsCourses.data) {
        const filteredSprintLevelLic = allInfo.peopleInformation.data.getpeopleInformation.license.filter(
          (prod: any) => {
            return (
              prod.productId === "20" ||
              prod.productId === "18" ||
              prod.productId === "21" ||
              prod.productId === "22" ||
              prod.productId === "23" ||
              prod.productId === "24" ||
              prod.productId === "25"
            );
          }
        );
        if (
          !allInfo.currentCourseDetails.isLoading &&
          !allInfo.currentCourseDetails.isFailed &&
          !allInfo.currentCourseDetails.data
        ) {
          const uuId = allInfo.common.luuId;
          const activeCourse = getCoursesByStatus(allInfo.tmsCourses.data.getTMSGetCourse);
          let courseId = 0;
          if (activeCourse.length > 0) {
            courseId = activeCourse[0].courseId;
          } else {
            let latestCompleted = allInfo.tmsCourses.data.getTMSGetCourse.filter(
              (courseFilter: any) => courseFilter.status === "5"
            );
            courseId =
              latestCompleted.length > 0
                ? latestCompleted.sort((a: any, b: any) => b.courseId - a.courseId)[0].courseId
                : 0;
          }
          setActiveCourse(activeCourse);
          if (filteredSprintLevelLic && filteredSprintLevelLic.length > 0) {
            dispatch(
              allActions.currentCourseDetailsAction.getStoreActiveCourseInfo(
                allInfo.common.leuId,
                filteredSprintLevelLic[0].licenseId,
                filteredSprintLevelLic[0].productId,
                uuId,
                courseId
              )
            );
          }
        }
      }
      if (allInfo.currentCourseDetails.isFailed) {
        setLoaderFlag(false);
        dispatch(allActions.toasterActions.showToastMessage(true, "error", "message_errorDefault"));
      }
    }
  }, [allInfo.peopleInformation, allInfo.currentCourseDetails, allInfo.tmsCourses]);
  

  return (
    <React.Fragment>
      <Toaster
        open={toastOptions.toastOpen}
        severity={toastOptions.toastSeverity}
        toasterClosed={toasterHandle}
        messageKey={toastOptions.toastMessageKey}
      />      
      <Loader showLoader={loaderFlag} />
      {true ? (
        <div className="progresspage-container">
          <div className="progresspage-title">
            <h1>{translate("progress_title")}</h1>
          </div>
          <div className="progresspage-body">
            <div className={classes.root}>
              <AppBar position="static" color="default" id="not-to-print" >
                <Tabs
                  value={productTabIndex}
                  className={"tabs-trigger-container h1-tab"}
                  onChange={handleProductChange}
                  indicatorColor="primary"
                  textColor="primary"
                  variant="scrollable"
                  scrollButtons="auto"
                  aria-label="Product list tabs"
                >
                  {productsList &&
                    productsList.map((product: any, mainIndex: number) => {
                      return (
                        <Tab
                          key={product.productId}
                          data-product={product.productId}
                          label={product.productName}
                          {...a11yProps_dynamic(mainIndex, "auto")}
                        />
                      );
                    })}
                </Tabs>
              </AppBar>
              {individualProgressPageLoading ? <div role="progressbar" className="circular-progress-container"><CircularProgress size={50} color="primary" /></div> : productsList &&
                productsList.map((product: any, listIndex: number) => {
                  if (product.productId === "15") {
                    return (
                      <TabPanel value={productTabIndex} index={listIndex} key={getRandomNumber(listIndex)} prodId={"auto"}>
                        {reachReportsCompletedList && reachReportsSkillList && reachReportSubSkillsList ? (
                          <div className="tab-main-body m0 p0">
                            <div className="completion-card-cover">
                              <CompletionCard
                                type="4"
                                title={translate("progress_overall_card_title_skillsCompleted")}
                                cardData={reachReportsCompletedList || {}}
                              />
                              <CompletionCard
                                type="5"
                                title={translate("progress_overall_card_title_badgesEarned")}
                                cardData={reachReportsCompletedList || {}}
                              />
                              <CompletionCard
                                type="6"
                                title={translate("progress_overall_card_title_missionsPassed")}
                                cardData={reachReportsCompletedList || {}}
                              />
                              <CompletionCard
                                type="7"
                                title={translate("progress_overall_card_title_timeInReach")}
                                cardData={reachReportsCompletedList || {}}
                              />
                            </div>
                            <div className="reach-skills-body-container">
                              <ul className="reach-skills-card-ul">
                                {reachReportsSkillList &&
                                  reachReportsSkillList.map((skill: any, index: number) => {
                                    return (
                                      <Accordion
                                        key={index}
                                        className={
                                          skill["UserCurrentGoal"] === 0
                                            ? "reach-skill-card"
                                            : "reach-skill-card user-selected"
                                        }
                                        expanded={expanded === `${skill["SkillId"]}`}
                                        onChange={handleAccordionChange(`${skill["SkillId"]}`)}
                                      >
                                        <AccordionSummary
                                          expandIcon={<ExpandMoreIcon />}
                                          aria-controls={skill.SkillId}
                                          id="panel1a-header"
                                        >
                                          <div className="reach-skill-title">
                                            {" "}
                                            {skill["SkillName"]}{" "}
                                            {parseInt(skill["UserCurrentGoal"]) === 1 &&
                                            parseInt(skill["IsAchieved"]) === 0 ? (
                                              <div className="inprogress-chip">{translate("progress_inprogress")}</div>
                                            ) : (
                                              ""
                                            )}
                                          </div>
                                        </AccordionSummary>
                                        <AccordionDetails className="accordion-details">
                                          <li className="reach-skills-card-li">
                                            <div className="reach-skill-subskill-list">
                                              <div className="missions-list-cover">
                                                {reachReportSubSkillsList && (
                                                  <div>
                                                    {renderReachSubSkill(reachReportSubSkillsList, skill["SkillId"])}
                                                  </div>
                                                )}
                                              </div>
                                            </div>
                                          </li>
                                        </AccordionDetails>
                                      </Accordion>
                                    );
                                  })}
                              </ul>
                            </div>
                          </div>
                        ) : (
                          <NoDataFound />
                        )}
                      </TabPanel>
                    );
                  } else if (product.productId === "25") {
                    return (
                      <TabPanel value={productTabIndex} index={listIndex} key={getRandomNumber(listIndex)} prodId={"auto"}>
                        {structuredElevateData && structuredElevateData.length > 0 ? (
                          <div className="tab-main-body m0 p0 inside-tab">
                            <div className="reach-skills-body-container">
                              <div className="levels-progress-skills-card-ul">
                                <div>
                                  <AppBar position="static" color="default">
                                    <Tabs
                                      value={elevateTab}
                                      onChange={handleElevateChange}
                                      className={"tabs-trigger-container h2-tab"}
                                      indicatorColor="primary"
                                      textColor="primary"
                                      variant="scrollable"
                                      scrollButtons="auto"
                                      aria-label="sprint levels level tabs"
                                    >
                                      {structuredElevateData &&
                                        structuredElevateData.map((indivSession: any, index: number) => {
                                          return (
                                            <Tab
                                              key={index}
                                              label={indivSession.level}
                                              {...a11yProps_dynamic(index, "25")}
                                            />
                                          );
                                        })}
                                    </Tabs>
                                  </AppBar>
                                  {structuredElevateData &&
                                    structuredElevateData.map((indivSession: any, index: number) => {
                                      return (
                                        <TabPanel
                                          value={elevateTab}
                                          index={index}
                                          key={getRandomNumber(index)}
                                          prodId={"25"}
                                        >
                                          {indivSession.parts &&
                                            indivSession.parts.length > 0 &&
                                            indivSession.parts.map((indivPart: any, index: number) => {
                                              return (
                                                <div key={index} className="parts-block">
                                                  {indivPart && indivPart.sessionsCompleted.length > 0 && (
                                                    <div className="completion-card-cover-elevate">
                                                      <div className="part-title">
                                                        {getPartTitle(indivPart.coursePartTitle)}
                                                      </div>
                                                      <CompletionCard
                                                        type="2"
                                                        title={translate("progress_overall_card_title_session")}
                                                        cardData={indivPart.statistics || {}}
                                                      />
                                                      <CompletionCard
                                                        type="3"
                                                        title={translate("progress_overall_card_title_certificate")}
                                                        cardData={indivPart.level || {}}
                                                        partTitle={indivPart.coursePartTitle}
                                                      />
                                                    </div>
                                                  )}
                                                  {indivPart.sessionsCompleted &&
                                                    indivPart.sessionsCompleted.length > 0 &&
                                                    indivPart.sessionsCompleted.map((session: any, index: number) => {
                                                      return (
                                                        <SubSkillCard
                                                          key={index}
                                                          subSkillData={session}
                                                          showHomeWork={false}
                                                          isSolo={false}
                                                          isElevate={true}
                                                        ></SubSkillCard>
                                                      );
                                                    })}
                                                </div>
                                              );
                                            })}
                                        </TabPanel>
                                      );
                                    })}
                                </div>
                              </div>
                            </div>
                          </div>
                        ) : (
                          <NoDataFound notProgressPage={true}/>
                        )}
                      </TabPanel>
                    );
                  } else if (product.productId === "20" || product.productId === "26" || product.productId === "27" || product.productId === "28") {
                    return (
                      <TabPanel value={productTabIndex} index={listIndex} key={getRandomNumber(listIndex)} prodId={"auto"}>
                        {levelList && levelList.length > 0 ? (
                          <div className="tab-main-body m0 p0 inside-tab">
                            <div className="reach-skills-body-container">
                              <div className="levels-progress-skills-card-ul">
                                <div>
                                  <AppBar position="static" color="transparent">
                                    <Tabs
                                    value={soloTab}
                                    onChange={handlesSoloChange}
                                    className={"tabs-trigger-container h2-tab"}
                                    indicatorColor="primary"
                                    textColor="primary"
                                    variant="scrollable"
                                    scrollButtons="auto"
                                    aria-label="sprint levels level tabs"
                                    >                                      
                                      {levelList && 
                                      levelList.map((level: any, index: number)=>{
                                       return(
                                            <Tab
                                              label={level.title}
                                              key={getRandomNumber(index)}
                                              {...a11yProps_dynamic(index, "21")}
                                            />
                                       );
                                      })
                                      }
                                    </Tabs>
                                  </AppBar>                                                                    
                                 {sololoaderFlag ? 
                                 <div className="circular-progress-container">
                                  <div className="circular-progress-img">
                                     <CircularProgress size={50} color="primary"/>
                                     </div>
                                 </div>
                                  :
                                  structuredNewSoloData && 
                                    structuredNewSoloData.map((skill: any, index: number) => {                                  
                                        return (
                                        <div key={getRandomNumber(index)} className="part-container">
                                          <div className="part-title">{translate("progress_partText")} {skill.courseTitle}</div>
                                          <div className="part-details-wrap">
                                            <ProgressCard 
                                              percentagePartCompleted={skill.percentagePartCompletedExercise} 
                                              percentagePartLabel="progress_overall_card_title_prework">
                                            </ProgressCard>
                                            <ProgressCard 
                                              percentagePartCompleted={skill.perPartSessionDetail}
                                              sessionCard={ true } 
                                              percentagePartLabel="progress_overall_card_title_session">
                                            </ProgressCard>
                                            <ProgressBadge skill={skill}>
                                            </ProgressBadge>
                                            <ProgressCertificate skill={skill}>
                                            </ProgressCertificate>
                                          </div>
                                          {skill && skill.courseDetailObj.map((individualModule: any, index: number) => {
                                            return (
                                            <div key={getRandomNumber(index)} className="module-wrap">
                                              <ProgressAccordion key={index} sessionModule={true} courseModule = { individualModule }></ProgressAccordion>
                                            </div>
                                            );
                                          })}
                                        </div>
                                        );
                                    })
                                  }                                 
                                </div>
                              </div>
                            </div>
                          </div>
                        ) : (
                          <NoDataFound />
                        )}
                      </TabPanel>
                    );
                  } else if (
                    (product.productId === "21" ||
                      product.productId === "22" ||
                      product.productId === "23" ||
                      product.productId === "24")
                  ) {                    
                    return (                      
                      <TabPanel key={listIndex} value={productTabIndex} index={listIndex} prodId={"auto"}>
                        {levelList && levelList.length > 0 ? (
                          <div className="tab-main-body m0 p0 inside-tab">
                            <div className="reach-skills-body-container">
                              <div className="levels-progress-skills-card-ul">
                                <div>
                                  <AppBar position="static" color="transparent">
                                    <Tabs
                                    value={soloTab}
                                    onChange={handlesSoloChange}
                                    className={"tabs-trigger-container h2-tab"}
                                    indicatorColor="primary"
                                    textColor="primary"
                                    variant="scrollable"
                                    scrollButtons="auto"
                                    aria-label="sprint levels level tabs"
                                    >                                      
                                      {levelList && 
                                      levelList.map((level: any, index: number)=>{
                                       return(
                                            <Tab
                                              label={level.title}
                                              key={getRandomNumber(index)}
                                              {...a11yProps_dynamic(index, "21")}
                                            />
                                       );
                                      })
                                      }
                                    </Tabs>
                                  </AppBar>                                                                    
                                 {sololoaderFlag ? 
                                 <div className="circular-progress-container">
                                  <div className="circular-progress-img">
                                     <CircularProgress size={50} color="primary"/>
                                     </div>
                                 </div>
                                  :
                                  structuredNewSoloData && 
                                    structuredNewSoloData.map((skill: any, index: number) => {                                  
                                        return(
                                        <div key={getRandomNumber(index)} className="part-container">
                                          <div className="part-title">{translate("progress_partText")} {skill.courseTitle}</div>
                                          <div className="part-details-wrap">
                                            <ProgressCard 
                                              percentagePartCompleted={skill.percentagePartCompletedExercise} 
                                              percentagePartLabel="progress_activity_tooltip_activitiesCompleted">
                                            </ProgressCard>
                                            <ProgressBadge skill={skill}></ProgressBadge>
                                            <ProgressCertificate skill={skill}></ProgressCertificate>
                                          </div>
                                         
                                          {skill && skill.courseDetailObj.map((individualModule: any, index: number) => {                                                                                        
                                            return (   
                                              <React.Fragment key={index}>                                           
                                              <div className="module-wrap">
                                                <ProgressAccordion courseModule = { individualModule }></ProgressAccordion>
                                               </div> 
                                               </React.Fragment>                                                                                        
                                            );
                                          })}
                                        </div>
                                        );
                                    })
                                  } 
                                </div>
                              </div>
                            </div>
                          </div>
                        ) : (
                          <NoDataFound />
                        )}
                      </TabPanel>
                    );
                  } else if (product.productId === "$0") {
                    return (
                      <TabPanel value={productTabIndex} index={listIndex} key={getRandomNumber(listIndex)} prodId={"auto"}>
                        <div className="test-results-all-cards-cover white">
                          <ChartsComponent pageInited={pageInited} />
                        </div>
                      </TabPanel>
                    );
                  } else if (product.productId === "$1") {
                    return (
                      <TabPanel value={productTabIndex} index={listIndex} key={getRandomNumber(listIndex)} prodId={"auto"}>
                        <div className="test-results-page">
                          {testResultsList && testResultsList.length > 0 ? (
                            testResultsList.map((result, index: number) => {
                              return <TestResultCard key={getRandomNumber(index)} result={result} productId={allInfo.common.productID}></TestResultCard>;
                            })
                          ) : (
                            <NoDataFound notProgressPage={true} />
                          )}
                        </div>
                        {testResultsList && testResultsList.length > 0 && <div className="test-result-msg">{translate("progress_test_result_timer_text")}</div>}
                      </TabPanel>
                    );
                  } else if (product.productId =="5" || product.productId == "6") {
                    return(
                    <TabPanel value={productTabIndex} index={listIndex} key={getRandomNumber(listIndex)} prodId={"auto"}>
                      <ProgressStep />
                  </TabPanel>
                  )
                  } else if (product.productId == "18" || product.productId == "29") {                
                    return (<TabPanel value={productTabIndex} index={listIndex} prodId={"auto"}  key={product.productId}>      
                      <LevelTabs />     
                      </TabPanel>);
                  } else {
                    return (
                      <TabPanel value={productTabIndex} index={listIndex} key={getRandomNumber(listIndex)} prodId={"auto"}>
                        <NoDataFound />
                      </TabPanel>
                    );
                  }
                })}
            </div>
          </div>
        </div>
      ) : (
        <ErrorPage status={404} />
      )}
    </React.Fragment>
  );
};

ProgressPage.propTypes = { productsList: PropTypes.array };

export default ProgressPage